// React polyfill to ensure React is available globally
import * as React from 'react';

// Ensure React is available globally
if (typeof window !== 'undefined') {
  (window as any).React = React;
}

export default React;